import React from 'react'
import styled from 'styled-components'
import moment from 'moment'
import 'moment/locale/ko'

// components
import { NewDateChart, NewMenuChart, NewTimeChart } from '../components'
import { Radio } from '../../../components/atom'

// globals
import * as TYPE from '../../../globals/type'

// utils
import { getPeriod } from '../../../utils/getPeriod'

// styles
import colors from '../../../styles/colors'

// images
import SelectOnImg from '../../../assets/image/select/ic-select-on.svg'
import SelectOffImg from '../../../assets/image/select/ic-select-off.svg'

// constants
const TIME_PERIOD_ITEM = [
  '07:00',
  '08:00',
  '09:00',
  '10:00',
  '11:00',
  '12:00',
  '13:00',
  '14:00',
  '15:00',
  '16:00',
  '17:00',
  '18:00',
  '19:00',
  '20:00',
  '21:00',
  '22:00',
  '23:00',
  '24:00',
]

function Chart({
  isMobile,
  chartDateItem,
  chartTimeItem,
  menuItem,
  startDate,
  endDate,
  orderIncludeCancel,
  selectRadioOpt,
  handleRadioOption,
  handleCheckBox,
}) {
  const renderChart = (opt) => {
    let period = getPeriod(startDate, endDate, 'YYYY-MM-DD')
    let date = []
    let count = []

    switch (opt) {
      case TYPE.CHART.DATE:
      case 0:
        // 응답 데이터 있음
        if (chartDateItem) {
          return <NewDateChart isMobile={isMobile} chartItem={chartDateItem} />
        }
        // 기본 데이터
        else {
          for (let i = 0; i < period.length; i++) {
            date.push(moment(period[i]).format('M.D'))
            count.push(0)
          }

          return (
            <NewDateChart
              isMobile={isMobile}
              chartItem={{ period: date, count }}
            />
          )
        }

      case TYPE.CHART.TIME:
      case 1:
        // 응답 데이터 있음
        if (chartTimeItem) {
          return <NewTimeChart isMobile={isMobile} chartItem={chartTimeItem} />
        }
        // 기본 데이터
        else {
          for (let i = 0; i < TIME_PERIOD_ITEM.length; i++) {
            count.push(0)
          }
          date.push(...TIME_PERIOD_ITEM)

          return (
            <NewTimeChart
              isMobile={isMobile}
              chartItem={{ period: date, count }}
            />
          )
        }
      case TYPE.CHART.MENU:
      case 2:
        // 응답 데이터 있음
        if (menuItem) {
          return <NewMenuChart isMobile={isMobile} chartItem={menuItem} />
        }
        // 기본 데이터
        else {
          return (
            <NewMenuChart
              isMobile={isMobile}
              chartItem={{ menu: [''], count: [0] }}
            />
          )
        }
      default:
        break
    }
  }

  return (
    <>
      <SelectWrapper>
        <RadioWrapper>
          <Radio
            options={[TYPE.CHART.DATE, TYPE.CHART.TIME, TYPE.CHART.MENU]}
            textColor={colors.BK}
            selectIdx={selectRadioOpt}
            onClickRadio={handleRadioOption}
          />
        </RadioWrapper>

        <CheckWrapper>
          <Check>
            <img
              src={!orderIncludeCancel ? SelectOnImg : SelectOffImg}
              onClick={handleCheckBox}
            />
            <span>취소된 주문 제외하기</span>
          </Check>
        </CheckWrapper>
      </SelectWrapper>

      <Container isLastChart={selectRadioOpt === 2}>
        {renderChart(selectRadioOpt)}
      </Container>
    </>
  )
}

export default Chart

const Container = styled.div`
  width: 100%;
  min-width: 320px;
  max-width: 768px;
  display: flex;
  flex-direction: column;
  border-radius: 15px;
  box-shadow: 0px 3px 12px rgba(0, 0, 0, 0.1);

  height: ${(props) => (props.isLastChart ? '220px' : '271px')};
  padding: ${(props) => (props.isLastChart ? '35px 0' : '44px 30px 35px 27px')};

  @media ${(props) => props.theme.mobile} {
    height: ${(props) => (props.isLastChart ? '340px' : '243px')};
    padding: ${(props) => (props.isLastChart ? '20px' : '31px 23px 20px 21px')};
  }
`

const SelectWrapper = styled.div`
  width: 100%;
  max-width: 768px;
  min-width: 320px;
  margin-top: 30px;
  margin-bottom: 20px;
  display: flex;

  @media (max-width: 600px) {
    flex-direction: column;
  }

  @media ${(props) => props.theme.mobile} {
    margin-bottom: 28px;
  }
`

const RadioWrapper = styled.div`
  display: flex;
`

const CheckWrapper = styled.div`
  flex: 1;
`

const Check = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;

  img {
    margin-right: 10px;
    width: 24px;
    height: 24px;
    cursor: pointer;
  }

  span {
    font-size: 16px;
    color: ${colors.BK};
  }

  @media (max-width: 600px) {
    justify-content: unset;
    margin-top: 14px;
  }

  @media ${(props) => props.theme.mobile} {
    img {
      width: 18px;
      height: 18px;
      margin-right: 6px;
    }

    span {
      font-size: 14px;
    }
  }
`
